import { Route, Switch } from "react-router-dom";

import FaireSourceAtcModalCtAsPage from "@faire/prototype-playground/workspace/sy/faire-source-atc-modal-ctas";
import FaireSourceCartSidebarPage from "@faire/prototype-playground/workspace/sy/faire-source-cart-sidebar";

export function SamanthaYeeRoutes() {
  return (
    <Switch>
      <Route path="/sy/faire-source-atc-modal-ctas" component={FaireSourceAtcModalCtAsPage} />
      <Route path="/sy/faire-source-cart-sidebar" component={FaireSourceCartSidebarPage} />
    </Switch>
  );
}

export const slug = "sy";
